import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { usersApi } from '../services/users.service';

/**
 * Hook para eliminar un usuario de la organización.
 *
 * @returns La mutation para eliminar el usuario.
 */
interface UseDeleteOrganizationUserVariables {
    organizationId: string;
    userId: string;
}

export const useDeleteOrganizationUser = (): UseMutationResult<
    { id: string },
    Error,
    UseDeleteOrganizationUserVariables
> => {
    return useMutation<{ id: string }, Error, UseDeleteOrganizationUserVariables>({
        mutationFn: async ({ organizationId, userId }: UseDeleteOrganizationUserVariables) => {
            if (!organizationId || !userId) {
                throw new Error('Organization ID y User ID son requeridos para eliminar un usuario');
            }
            const response = await usersApi.deleteOrganizationUser(organizationId, userId);
            return response.data;
        },
    });
};
